<ct-lib-info-banner>
  <p>{{ 'jobboard.platform.settings.delete.info' | transloco }}</p>
</ct-lib-info-banner>
<app-button variant="white-red" (click)="openModal()">
  {{ 'jobboard.platform.settings.delete.button' | transloco }}
</app-button>

<ct-lib-modal
  #deleteModal
  [small]="true"
  [label]="'jobboard.platform.settings.delete.modal-title' | transloco"
  [footer]="deleteModalFooter"
>
  <p>{{ 'jobboard.platform.settings.delete.modal-text' | transloco }}</p>
  <form [formGroup]="confirmForm">
    <div
      class="form-group mt-3"
      [class.invalid]="confirmForm.controls.confirmValue.invalid && submitAttempt()"
    >
      <input
        type="text"
        class="form-control"
        formControlName="confirmValue"
        [placeholder]="'jobboard.platform.settings.delete.confirm-placeholder' | transloco: { word: confirmationWord() }"
        autocomplete="off"
      />
      @if (submitAttempt()) {
        <div class="validation">
          @if (confirmForm.controls.confirmValue.errors?.['required']) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
          }
          @if (confirmForm.controls.confirmValue.errors?.['incorrect']) {
            <p>{{ 'jobboard.platform.settings.delete.confirm-mismatch' | transloco: { word: confirmationWord() } }}</p>
          }
        </div>
      }
    </div>
  </form>
</ct-lib-modal>

<ng-template #deleteModalFooter>
  <div class="d-flex flex-wrap align-items-center gap-3">
    <app-button variant="white-grey" (click)="deleteModal.close()">
      {{ 'jobboard.platform.settings.delete.cancel' | transloco }}
    </app-button>
    <app-button variant="white-red" [loading]="deleting()" (click)="confirmDelete()">
      {{ 'jobboard.platform.settings.delete.final' | transloco }}
    </app-button>
  </div>
</ng-template>
